import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthController } from '../controller/auth.controller';
import type { UserRole } from '../model';
import { AppRoutes } from '@/app/routes';
import { loginRedirectState } from '../screen/loginRedirect';

interface ProtectedRouteProps {
  children: ReactNode;
  roles?: UserRole[];
  /** @deprecated Club is no longer required for navigation */
  requiresClub?: boolean;
}

export const ProtectedRoute = ({ children, roles }: ProtectedRouteProps) => {
  const { user, hasRole } = useAuthController();
  const location = useLocation();

  if (!user) {
    // A shared or bookmarked link must survive the login step.
    return <Navigate to={AppRoutes.auth.login} state={loginRedirectState(location)} replace />;
  }

  if (roles && !hasRole(roles)) {
    return <Navigate to={AppRoutes.dashboard.home} replace />;
  }

  return <>{children}</>;
};
